import { SearchSubscriptionEnvironmentConfig } from './search-subscription-environment-config';

export const environment: SearchSubscriptionEnvironmentConfig = {
  production: true,
  language: 'de',
  apiBaseUrl: '',
  apiBasicAuth: '',
  objectSearchUrl: '',
  countries: ['CH', 'LI'],
  isResidia: false,
};
